import EngineFamily from "../../engineFamily/pages";
import requireAuth from "../../../../utils/requireAuth"
import AircraftFamily from "../../aircraftFamily/pages";
import Region from "../../region/pages"
import AircraftModels from "../../aircraftModels/pages"
import ApuTypes from "../../apuTypes/pages";
import EngineTypes from "../../engineTypes/pages";
import AircraftTypes from "../../aircraftTypes/pages";
import Manufacturers from "../../manufacturers/pages"
import LgSubAssemblies from "../../lgSubAssemblies/pages"
import EngineLlpsConfig from "../../engineLlpsConfig/pages"
import MaintenancePrograms from "../../maintenancePrograms/pages"
import AircraftTypeView from "../../aircraftTypes/component/AircraftTypeView";
import EngineFamilyView from "../../engineFamily/component/EngineFamilyView";
import EngineTypeView from "../../engineTypes/components/EngineTypeView";
import LlpPartView from "../../engineLlpsConfig/components/LlpPartView";
import ApuTypeView from "../../apuTypes/components/ApuTypeView";
import RoleBasedAccess from "../../../../utils/RoleBasedAccess";
import { STCsMods } from "../../../config/components";
import LesseeConfig from "../../lesseeConfig/LesseeConfig";
import OwnerLessor from "../../ownerLessor/OwnerLessor";
import Bankings from "../../bankingDetail/pages/Bankings";
import DistributionEmails from "../../distributionEmails/DistributionEmails";
import ContactList from "../../contactList/ContactList";
import AssetStatus from "../../assetStatus/pages"
import InventoryType from "../../InventoryType/pages";
export const configRoute = [
     {
        path:'config-data/assetStatus',
        component:requireAuth(AssetStatus),
        key:'status'
    },
    {
        path:'config-data/inventory-list',
        component:requireAuth(RoleBasedAccess(InventoryType,['config_data', 'inventory_config','R'],true)),
        key:'manufacturers'
    },
    {
        path:'config-data/manufacturers',
        component:requireAuth(RoleBasedAccess(Manufacturers,['config_data', 'manufacturers','R'],true)),
        key:'manufacturers'
    },
    {
        path:'config-data/aircraftFamily',
        component:requireAuth(RoleBasedAccess(AircraftFamily,['config_data', 'aircraft_family','R'],true)),
        key:'aircraftFamily'
    },
    {
        path:'config-data/aircraftTypes',
        component:requireAuth(RoleBasedAccess(AircraftTypes,['config_data', 'aircraft_types','R'],true)),
        key:'aircraftTypes'
    },
    {
        path:'config-data/aircraftModels',
        component:requireAuth(RoleBasedAccess(AircraftModels,['config_data', 'aircraft_models','R'],true)),
        key:'aircraftModels'
    },
    {
        path:'config-data/engineFamily',
        component:requireAuth(RoleBasedAccess(EngineFamily,['config_data', 'engine_family','R'],true)),
        key:'engineFamily'
    },
    {
        path:'config-data/engineTypes',
        component:requireAuth(RoleBasedAccess(EngineTypes,['config_data', 'engine_types','R'],true)),
        key:'engineTypes'
    },
    {
        path:'config-data/apuTypes',
        component:requireAuth(RoleBasedAccess(ApuTypes,['config_data', 'apu_types','R'],true)),
        key:'apuTypes'
    },
    {
        path:'config-data/lgSubAssemblies',
        component:requireAuth(RoleBasedAccess(LgSubAssemblies,['config_data', 'lg_sub_assemblies','R'],true)),
        key:'lgSubAssemblies'
    },
    {
        path:'config-data/region',
        component:requireAuth(RoleBasedAccess(Region,['config_data', 'region','R'],true)),
        key:'region'
    },
    {
        path:'config-data/engineLlpsConfig',
        component:requireAuth(RoleBasedAccess(EngineLlpsConfig,['config_data', 'engine_llp_config','R'],true)),
        key:'engineLlpsConfig'
    },
    {
        path:'config-data/maintenancePrograms',
        component:requireAuth(RoleBasedAccess(MaintenancePrograms,['config_data', 'maintenance_program','R'],true)),
        key:'maintenancePrograms'
    },
    {
        path: 'config-data/stc-mods',
        component: requireAuth(RoleBasedAccess(STCsMods, ['config_data', 'stcs_&_mods', 'R'], true)),
        key: 'stcMods'
    },
    {
        path: 'config-data/distribution',
        component: requireAuth(RoleBasedAccess(DistributionEmails, ['config_data', 'distribution_emails', 'R'], true)),
        key: 'distribution'
    },
    {
        path: 'config-data/owner-lessor',
        component: requireAuth(RoleBasedAccess(OwnerLessor, ['config_data', 'owner_&_lessor', 'R'], true)),
        key: 'owner-lessor'
    },
    {
        path: 'config-data/banking-details',
        component: requireAuth(RoleBasedAccess(Bankings, ['config_data', 'banking_details', 'R'], true)),
        key: 'banking-details'
    },
    {
        path: 'config-data/lessee-config',
        component: requireAuth(RoleBasedAccess(LesseeConfig, ['config_data', 'lessee_config', 'R'], true)),
        key: 'lessee-config'
    },
    {
        path: 'config-data/contact-list',
        component: requireAuth(RoleBasedAccess(ContactList, ['config_data', 'contact_list', 'R'], true)),
        key: 'contact-list'
    },
    {
        path:'config-data/aircraftTypes/View/:id',
        component:requireAuth(AircraftTypeView),
        key:'aircraftTypeView'
    },
    {
        path:'config-data/engineFamily/View/:id',
        component:requireAuth(EngineFamilyView),
        key:'engineFamilyView'
    },
    {
        path:'config-data/engineType/View/:id',
        component:requireAuth(EngineTypeView),
        key:'engineTypeView'
    },
    {
        path:'config-data/engineLlpsConfig/llpPart/View/:id',
        component:requireAuth(LlpPartView),
        key:'llpPartView'
    },
    {
        path:'config-data/apuTypes/View/:id',
        component:requireAuth(ApuTypeView),
        key:'apuTypeView'
    },
]